export const STATE_DEFS = [
  { key: 'todo',       label: 'ToDo',    color: 'default', bgcolor: '#B4B4B4', textcolor: 'rgba(0,0,0,0.75)' },
  { key: 'draft',      label: 'Draft',   color: 'error',   bgcolor: '#D44350', textcolor: '#fff'              },
  { key: 'review',     label: 'Review',  color: 'warning', bgcolor: '#FCC204', textcolor: 'rgba(0,0,0,0.75)' },
  { key: 'done',       label: 'Done',    color: 'success', bgcolor: '#2E8B57', textcolor: '#fff'              },
  
] as const
